import { Container, Section } from '@repo/ui'
import { BlogCTA } from './components/cta'
import { BlogHeader } from './components/header'
import { BlogPosts } from './components/list'
import { getAllBlogPosts } from './data'

export function BlogPage() {
  const posts = getAllBlogPosts()

  return (
    <Section variant="default" className="md:pt-24">
      <article>
        <Container size="content">
          <BlogHeader />
          <BlogPosts posts={posts} />
          <BlogCTA />
        </Container>
      </article>
    </Section>
  )
}
